import "../common/globals";

import React, { useState, useEffect } from "react";
import { extractSummary, extractTitle } from "./../utils/glance";

import CookiePop from "../components/CookiePop";
import Head from "next/head";
import dynamic from "next/dynamic";
import { extractThumbnail } from "./../utils/glance";
import getConfig from "next/config";
import { getInitialPropsForGlance } from "../common/page-props";
import {
  useGlances,
  getGlancesWithBubblesForRender
} from "../utils/useGlances";
import { useRouter } from "next/router";
import styled from "@emotion/styled";
import { Global } from "@emotion/core";
import { getUrbanist } from "../common/styles";

import { getParameterByName } from "../utils/tracking";

const { publicRuntimeConfig } = getConfig();

const GlanceListWithHighlights = dynamic(() =>
  import("../components/GlanceListWithHighlights")
);

const Container = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  max-width: 450px;
  margin: auto;
  background-color: #fff;
  overflow: hidden;
`;

function Page(props) {
  const state = useGlances(props);
  const [glance] = props.glances;
  const title = extractTitle(glance) || "Glance - The Internet Starts here";
  const description = extractSummary(glance);
  const router = useRouter();
  const foreignRegions = ["JP", "ID"];

  const [enableAutoPlay, setEnableAutoPlay] = useState(false);
  const [hideOptionsMenuAndShare, setHideOptionsMenuAndShare] = useState(true);

  const glancesForRender = getGlancesWithBubblesForRender(
    state.glances,
    true,
    hideOptionsMenuAndShare
  );

  const onCookieAcceptance = React.useCallback(
    flag => {
      setEnableAutoPlay(!flag);
    },
    [setEnableAutoPlay]
  );

  useEffect(() => {
    setHideOptionsMenuAndShare(
      getParameterByName("source", window.location.href) ===
        "api-integration" ||
        (getParameterByName("region", window.location.href) &&
          foreignRegions.some(region =>
            getParameterByName("region", window.location.href).includes(region)
          )) ||
        getParameterByName("source", window.location.href) ===
          "sports-destination"
    );
  }, [foreignRegions]);

  useEffect(() => {
    if (
      glance &&
      glance.id &&
      props.params &&
      props.params.g &&
      !props.params.utm_source
    ) {
      const region = getParameterByName("region", window.location.href);
      const regionParam = region ? `&region=${region}` : "";

      router.push(
        "/story?g=" +
          glance.id +
          "&utm_source=Glance&utm_medium=lockscreen" +
          regionParam
      );
    }
  }, [glance, props.params, router]);

  return (
    <Container>
      <Global
        styles={`* {box-sizing: border-box;} #__next { height: 100%;}${getUrbanist()}html, body{ padding: 0;margin: 0 auto;background-color: #000; max-width: 450px;} `}
      />
      {!hideOptionsMenuAndShare && (
        <CookiePop referer={props.referer} onChange={onCookieAcceptance} />
      )}
      <Head>
        <title key="title">{title}</title>
        <meta key="description" property="description" content={description} />
        <meta key="og:title" property="og:title" content={title} />
        <meta
          key="og:description"
          property="og:description"
          content={description}
        />
        <meta
          key="og:url"
          property="og:url"
          content={
            glance && glance.id
              ? "/story/" + glance.id
              : publicRuntimeConfig.domain
          }
        />
        <meta
          key="og:image"
          property="og:image"
          content={extractThumbnail(glance)}
        />
      </Head>
      <GlanceListWithHighlights
        glances={glancesForRender}
        isSourceApiIntegration={hideOptionsMenuAndShare}
      />
    </Container>
  );
}

Page.getInitialProps = getInitialPropsForGlance;

export default Page;
